// import PropTypes from 'prop-types'
import BaseUIProductGroupView from 'xui/modules/productGroup/BaseUIProductGroupView'

export default class ProductGroupView extends BaseUIProductGroupView {}
